<div class="row text-center ma-font-setup">
  <div class="col">
    <h1 class="title-copy">
      {{ "VALIDATE_WITH_EMAIL" | translate }}
    </h1>
    <p class="mb-0">
      {{ "EMAIL_IS_ASSOCIATED_WITH_YOUR_POLICY" | translate }}
    </p>
    <P>
      {{ "CONFIRM_EMAIL_TO_FINISH_ACCOUNT_SETUP" | translate }}
    </P>
    <div class="email-title mb-4 mt-4 fs-18 lh24">
      <b>{{ email }}</b>
    </div>
    <mapfre-button
      additionalClasses="basic primary large-btn margin-bottom mb24"
      (click)="sendEmail()"
    >
      {{ "CONTINUE" | translate }}
    </mapfre-button>
    <ng-container *ngIf="isAcmic; else MAstate">
      <div class="margin-bottom mb24 ">
        <div class="assistance acmic margin-top mt16">
        <p class="no-margin-bottom">
          {{ "UPDATE_YOUR_EMAIL" | translate }}
        </p>
        <p>
            {{ "CONTATC_US_AT" | translate }}
          </p>
            <a class="underline mapfre link blue-link" href="tel:18442954500">
              {{ "TELL_NUMBER" | translate}}
            </a>
        </div>
      </div>
    </ng-container>
    <ng-template #MAstate>
       <div class="s-code" *ngIf="!inactiveAccount">
      <mapfre-button
        (click)="sendToAccountVerification()"
        additionalClasses="link ghost secondary warn-ghost font-size-16 small no-margin btn small-btn"
      >
        {{ "USE_A_DIFFERENT_EMAIL" | translate }}
      </mapfre-button>
    </div>
  </ng-template>
  </div>
</div>
